<template>
    <div>
        <div class="row mb-1">
            <div class="col-12 col-md-4" :class="{'validation-error': errors.has('etunimi')}">
                <label for="etunimi">Etunimi</label>
                <input type="text" name="etunimi" id="etunimi" class="form-control" v-model="firstName" :disabled="disabled" v-validate="'required'">
                <span class="validation-error--message text-muted">{{ errors.first('etunimi') }}</span>
            </div>
            <div class="col-12 col-md-4" :class="{'validation-error': errors.has('sukunimi')}">
                <label for="sukunimi">Sukunimi</label>
                <input type="text" name="sukunimi" id="sukunimi" class="form-control" v-model="lastName" :disabled="disabled" v-validate="'required'">
                <span class="validation-error--message text-muted">{{ errors.first('sukunimi') }}</span>
            </div>
            <div class="col-12 col-md-4" :class="{'validation-error': errors.has('email')}">
                <label for="email">Sähköposti</label>
                <input type="email" name="email" id="email" class="form-control" v-model="email" :disabled="disabled" v-validate="'required|email'">
                <span class="validation-error--message text-muted">{{ errors.first('email') }}</span>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-12">
                <fieldset class="form-group" :class="{'validation-error': errors.has('dealer')}">
                    <label>Toyota-liike</label>
                    <v-select v-model="dealer" :options="dealers" label="name" name="dealer" :disabled="disabled" v-validate="'required'"></v-select>
                    <span class="validation-error--message text-muted">{{ errors.first('dealer') }}</span>
                </fieldset>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import bus from "../bus";
export default {
  props: {
    disabled: {
      type: Boolean,
      required: false
    }
  },
  mounted() {
    bus.$on("validate", () => {
      return this.$validator.validate("*");
    });
  },
  computed: {
    ...mapGetters({
      dealers: "getDealers"
    }),
    firstName: {
      get() {
        return this.$store.state.form.form.firstName;
      },
      set(value) {
        this.$store.commit("setFirstName", value);
      }
    },
    lastName: {
      get() {
        return this.$store.state.form.form.lastName;
      },
      set(value) {
        this.$store.commit("setLastName", value);
      }
    },
    email: {
      get() {
        return this.$store.state.form.form.email;
      },
      set(value) {
        this.$store.commit("setEmail", value);
      }
    },
    dealer: {
      get() {
        return this.$store.state.form.form.dealer;
      },
      set(value) {
        this.$store.commit("setDealer", value);
      }
    }
  }
};
</script>

<style>
</style>
